import {ENDPOINT_ADMIN_MS_PAUSE, ENDPOINT_ADMIN_MS_RUN, ENDPOINT_ADMIN_MS_STATE} from "../../constants/api";

const Emitter = require('mn-utils/Emitter');
const map = require('mn-utils/map');
const toLower = require('mn-utils/toLower');
const {
  MAILSYSTEM_STATE_PAUSED,
  MAILSYSTEM_STATE_RUNNING,
  MAILSYSTEM_STATE_AUTO_PAUSED,
  MAILSYSTEM_RUN_REGISTRATION,
  MAILSYSTEM_RUN_BOT,
} = require('../../constants/mailsystem');
const {
  apiRequestAdmin,
} = require('../ws');


const mockMailSystemStates$ = new Emitter([
  {
    sender: MAILSYSTEM_RUN_REGISTRATION,
    state: MAILSYSTEM_STATE_AUTO_PAUSED,
    count: 10,
    limit: 1000,
  },
  {
    sender: MAILSYSTEM_RUN_BOT,
    state: MAILSYSTEM_STATE_AUTO_PAUSED,
    count: 17,
    limit: 1000,
  },
]);


export function apiAdminMailSystemStates(params) {
  return apiRequestAdmin(ENDPOINT_ADMIN_MS_STATE, params, () => {
    return {
      states: mockMailSystemStates$.getValue(),
    };
  }).then((v) => {
    return {
      ...v,
      states: map(v.states, (v) => ({
        ...v,
        state: toLower(v.state),
      })),
    };
  });
}
export function apiAdminMailSystemRun(params) {
  return apiRequestAdmin(ENDPOINT_ADMIN_MS_RUN, params, () => {
    const sender = params.sender;
    mockMailSystemStates$.emit(map(mockMailSystemStates$.getValue(), (v) => {
      return v.sender === sender ? {
        ...v,
        state: MAILSYSTEM_STATE_RUNNING,
      } : v;
    }));
  });
}
export function apiAdminMailSystemPause(params) {
  return apiRequestAdmin(ENDPOINT_ADMIN_MS_PAUSE, params, () => {
    const sender = params.sender;
    mockMailSystemStates$.emit(map(mockMailSystemStates$.getValue(), (v) => {
      return v.sender === sender ? {
        ...v,
        state: MAILSYSTEM_STATE_PAUSED,
      } : v;
    }));
  });
}
